import { createSelector } from "reselect";
export var lpsSelector = function(state) {
    return state.lps;
};
export var getAuthorizedLpsSelector = createSelector(lpsSelector, function(param) {
    var authorizedLps = param.authorizedLps;
    return authorizedLps;
});
export var getAuthorizedDSPsSelector = createSelector(lpsSelector, function(param) {
    var authorizedDSPs = param.authorizedDSPs;
    return authorizedDSPs;
});
export var getAuthorizedLpSelectedSelector = createSelector(lpsSelector, function(param) {
    var lpSelected = param.lpSelected;
    return lpSelected;
});
export var getAuthorizedEntitiesSelector = createSelector(lpsSelector, function(param) {
    var authorizedEntities = param.authorizedEntities;
    return authorizedEntities;
});
export var lpPickerInputSelector = createSelector(lpsSelector, function(param) {
    var lpPickerInput = param.lpPickerInput;
    return lpPickerInput;
});

//# sourceMappingURL=selectors.js.map